// extracted by mini-css-extract-plugin
module.exports = {"itemImageArea":"ImageCover_itemImageArea__JPRQw","itemImage":"ImageCover_itemImage__3dnfL"};